"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockDiagramLayerId = exports.BLOCK_DIAGRAM_CUSTOM_TYPE_PREFIX = exports.BLOCK_DIAGRAM_DESIGN_ID = exports.BLOCK_DIAGRAM_LAYER_SET_ID = void 0;
exports.buildBlockDiagramLayers = buildBlockDiagramLayers;
exports.edgeLayerId = edgeLayerId;
exports.blockLayerIds = blockLayerIds;
exports.blockCustomTypeName = blockCustomTypeName;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const voltage_1 = require("../layout/voltage");
exports.BLOCK_DIAGRAM_LAYER_SET_ID = 'block-diagram';
exports.BLOCK_DIAGRAM_DESIGN_ID = 'block-diagram';
exports.BLOCK_DIAGRAM_CUSTOM_TYPE_PREFIX = 'cadstrom.blockDiagram';
var BlockDiagramLayerId;
(function (BlockDiagramLayerId) {
    BlockDiagramLayerId[BlockDiagramLayerId["EdgeLabels"] = 1] = "EdgeLabels";
    BlockDiagramLayerId[BlockDiagramLayerId["BlockName"] = 2] = "BlockName";
    BlockDiagramLayerId[BlockDiagramLayerId["BlockSub"] = 3] = "BlockSub";
    BlockDiagramLayerId[BlockDiagramLayerId["BlockOutlineProcessor"] = 4] = "BlockOutlineProcessor";
    BlockDiagramLayerId[BlockDiagramLayerId["BlockOutlinePower"] = 5] = "BlockOutlinePower";
    BlockDiagramLayerId[BlockDiagramLayerId["BlockOutlineConnector"] = 6] = "BlockOutlineConnector";
    BlockDiagramLayerId[BlockDiagramLayerId["BlockOutlineGeneric"] = 7] = "BlockOutlineGeneric";
    BlockDiagramLayerId[BlockDiagramLayerId["BlockFillProcessor"] = 8] = "BlockFillProcessor";
    BlockDiagramLayerId[BlockDiagramLayerId["BlockFillPower"] = 9] = "BlockFillPower";
    BlockDiagramLayerId[BlockDiagramLayerId["BlockFillConnector"] = 10] = "BlockFillConnector";
    BlockDiagramLayerId[BlockDiagramLayerId["BlockFillGeneric"] = 11] = "BlockFillGeneric";
    BlockDiagramLayerId[BlockDiagramLayerId["RailRank0"] = 12] = "RailRank0";
    BlockDiagramLayerId[BlockDiagramLayerId["RailRank1"] = 13] = "RailRank1";
    BlockDiagramLayerId[BlockDiagramLayerId["RailRank2"] = 14] = "RailRank2";
    BlockDiagramLayerId[BlockDiagramLayerId["RailRank3"] = 15] = "RailRank3";
    BlockDiagramLayerId[BlockDiagramLayerId["RailRank4"] = 16] = "RailRank4";
    BlockDiagramLayerId[BlockDiagramLayerId["RailRank5"] = 17] = "RailRank5";
    BlockDiagramLayerId[BlockDiagramLayerId["RailRank6"] = 18] = "RailRank6";
    BlockDiagramLayerId[BlockDiagramLayerId["RailUnranked"] = 19] = "RailUnranked";
    BlockDiagramLayerId[BlockDiagramLayerId["EdgeBus"] = 20] = "EdgeBus";
    BlockDiagramLayerId[BlockDiagramLayerId["EdgeControl"] = 21] = "EdgeControl";
    BlockDiagramLayerId[BlockDiagramLayerId["EdgeAnalog"] = 22] = "EdgeAnalog";
    BlockDiagramLayerId[BlockDiagramLayerId["BoardLabel"] = 23] = "BoardLabel";
    BlockDiagramLayerId[BlockDiagramLayerId["BoardOutline"] = 24] = "BoardOutline";
})(BlockDiagramLayerId || (exports.BlockDiagramLayerId = BlockDiagramLayerId = {}));
const { SchLayerType, UnknownLayerType } = sigma_engine_shared_1.DesignModels;
function buildBlockDiagramLayers(showEdgeLabels) {
    const layers = [
        {
            id: BlockDiagramLayerId.EdgeLabels,
            name: 'edge-labels',
            friendlyName: 'Edge labels',
            type: SchLayerType.Label,
            defaultVisible: showEdgeLabels,
        },
        {
            id: BlockDiagramLayerId.BlockName,
            name: 'block-name',
            friendlyName: 'Block names',
            type: SchLayerType.NameLabel,
            defaultVisible: true,
        },
        {
            id: BlockDiagramLayerId.BlockSub,
            name: 'block-sub',
            friendlyName: 'Block subtitles',
            type: SchLayerType.ValueLabel,
            defaultVisible: true,
        },
        {
            id: BlockDiagramLayerId.BlockOutlineProcessor,
            name: 'block-outline-processor',
            friendlyName: 'Processor outlines',
            type: SchLayerType.Symbol,
            defaultVisible: true,
        },
        {
            id: BlockDiagramLayerId.BlockOutlinePower,
            name: 'block-outline-power',
            friendlyName: 'Power outlines',
            type: SchLayerType.Symbol,
            defaultVisible: true,
        },
        {
            id: BlockDiagramLayerId.BlockOutlineConnector,
            name: 'block-outline-connector',
            friendlyName: 'Connector outlines',
            type: SchLayerType.Symbol,
            defaultVisible: true,
        },
        {
            id: BlockDiagramLayerId.BlockOutlineGeneric,
            name: 'block-outline-generic',
            friendlyName: 'Block outlines',
            type: SchLayerType.Symbol,
            defaultVisible: true,
        },
        {
            id: BlockDiagramLayerId.BlockFillProcessor,
            name: 'block-fill-processor',
            friendlyName: 'Processor fills',
            type: SchLayerType.Background,
            defaultVisible: true,
        },
        {
            id: BlockDiagramLayerId.BlockFillPower,
            name: 'block-fill-power',
            friendlyName: 'Power fills',
            type: SchLayerType.Background,
            defaultVisible: true,
        },
        {
            id: BlockDiagramLayerId.BlockFillConnector,
            name: 'block-fill-connector',
            friendlyName: 'Connector fills',
            type: SchLayerType.Background,
            defaultVisible: true,
        },
        {
            id: BlockDiagramLayerId.BlockFillGeneric,
            name: 'block-fill-generic',
            friendlyName: 'Block fills',
            type: SchLayerType.Background,
            defaultVisible: true,
        },
    ];
    for (let rank = 0; rank < voltage_1.VOLTAGE_RANK_COUNT; rank++) {
        layers.push({
            id: BlockDiagramLayerId.RailRank0 + rank,
            name: `rail-rank-${rank}`,
            friendlyName: `Power rails (rank ${rank})`,
            type: SchLayerType.Wire,
            defaultVisible: true,
        });
    }
    layers.push({
        id: BlockDiagramLayerId.RailUnranked,
        name: 'rail-unranked',
        friendlyName: 'Power rails (unranked)',
        type: SchLayerType.Wire,
        defaultVisible: true,
    }, {
        id: BlockDiagramLayerId.EdgeBus,
        name: 'edge-bus',
        friendlyName: 'Buses',
        type: SchLayerType.Bus,
        defaultVisible: true,
    }, {
        id: BlockDiagramLayerId.EdgeControl,
        name: 'edge-control',
        friendlyName: 'Control signals',
        type: SchLayerType.Wire,
        defaultVisible: true,
    }, {
        id: BlockDiagramLayerId.EdgeAnalog,
        name: 'edge-analog',
        friendlyName: 'Analog signals',
        type: SchLayerType.Wire,
        defaultVisible: true,
    }, {
        id: BlockDiagramLayerId.BoardLabel,
        name: 'board-label',
        friendlyName: 'Board caption',
        type: UnknownLayerType.Other,
        defaultVisible: true,
    }, {
        id: BlockDiagramLayerId.BoardOutline,
        name: 'board-outline',
        friendlyName: 'Board outline',
        type: UnknownLayerType.Other,
        defaultVisible: true,
    });
    return layers;
}
function edgeLayerId(kind, voltageRank) {
    switch (kind) {
        case 'rail':
            return voltageRank === null || voltageRank === undefined ?
                BlockDiagramLayerId.RailUnranked
                : BlockDiagramLayerId.RailRank0 + Math.min(voltageRank, voltage_1.VOLTAGE_RANK_COUNT - 1);
        case 'bus':
            return BlockDiagramLayerId.EdgeBus;
        case 'control':
            return BlockDiagramLayerId.EdgeControl;
        case 'analog':
            return BlockDiagramLayerId.EdgeAnalog;
    }
}
function blockLayerIds(kind) {
    switch (kind) {
        case 'processor':
            return { fill: BlockDiagramLayerId.BlockFillProcessor, outline: BlockDiagramLayerId.BlockOutlineProcessor };
        case 'power':
            return { fill: BlockDiagramLayerId.BlockFillPower, outline: BlockDiagramLayerId.BlockOutlinePower };
        case 'connector':
            return { fill: BlockDiagramLayerId.BlockFillConnector, outline: BlockDiagramLayerId.BlockOutlineConnector };
        case 'other':
            return { fill: BlockDiagramLayerId.BlockFillGeneric, outline: BlockDiagramLayerId.BlockOutlineGeneric };
    }
}
function blockCustomTypeName(kind) {
    return `${exports.BLOCK_DIAGRAM_CUSTOM_TYPE_PREFIX}.${kind === 'other' ? 'block' : kind}`;
}
//# sourceMappingURL=layers.js.map